import React, { useState, useRef } from "react";
import "../../assets/styles/patients.scss";
import AddVisitsForPatient from "../visits/addVisitsForPatient";
import AddOrEditPatient from "../../components/features/patients/addOrEditPatient";
import PatientDeleteConfirmation from "../../components/features/patients/PatientDeleteConfirmation";
import PatientDashboard from "../../components/features/patients/PatientDashboard";
import PatientList from "../../components/features/patients/PatientList";

const Patients = () => {
  const [isAddPatientModalVisible, setIsAddPatientModalVisible] =
    useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isAddVisitModalVisible, setIsAddVisitModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const patientListRef = useRef(null);

  const handleAddPatientClick = (event) => {
    if (event === "addPatient") setIsAddPatientModalVisible((prev) => !prev);
  };

  const handleEditPatient = (patientId) => {
    setSelectedPatientId(patientId);
    setIsEditModalVisible(true);
  };

  const handleAddVisit = (patientId) => {
    setSelectedPatientId(patientId);
    setIsAddVisitModalVisible(true);
  };

  const handleDeletePatient = (patientId) => {
    setSelectedPatientId(patientId);
    setIsDeleteModalVisible(true);
  };

  const refreshPatientList = () => {
    if (patientListRef.current) {
      patientListRef.current.refresh();
    }
  };

  return (
    <div className="Patients__main-container">
      <PatientDashboard />

      <PatientList
        ref={patientListRef}
        onAddPatientClick={handleAddPatientClick}
        onEditPatient={handleEditPatient}
        onAddVisit={handleAddVisit}
        onDeletePatient={handleDeletePatient}
      />

      {isAddPatientModalVisible && (
        <AddOrEditPatient
          mode="add"
          visible={isAddPatientModalVisible}
          setVisible={(bool, refresh) => {
            setIsAddPatientModalVisible(bool);
            if (refresh) refreshPatientList();
          }}
          initCallBack={refreshPatientList}
        />
      )}

      {isEditModalVisible && (
        <AddOrEditPatient
          mode="edit"
          patient={[]}
          profile="patient"
          visible={isEditModalVisible}
          id={selectedPatientId}
          setVisible={(bool, refresh) => {
            setIsEditModalVisible(bool);
            if (!bool) setSelectedPatientId(null);
            if (refresh) refreshPatientList();
          }}
          initCallBack={refreshPatientList}
        />
      )}

      {isAddVisitModalVisible && (
        <AddVisitsForPatient
          patientId={selectedPatientId}
          visible={isAddVisitModalVisible}
          setVisible={(bool) => {
            setIsAddVisitModalVisible(bool);
            if (!bool) setSelectedPatientId(null);
          }}
        />
      )}
      {isDeleteModalVisible && (
        <PatientDeleteConfirmation
          visible={isDeleteModalVisible}
          patient={{ patient_id: selectedPatientId }}
          patientPage
          setVisible={(bool, final) => {
            setIsDeleteModalVisible(bool);
            if (!bool) setSelectedPatientId(null);
            if (final) {
              refreshPatientList();
            }
          }}
        />
      )}
    </div>
  );
};

export default Patients;
